import Table from "../table/Table"
import { usePagination } from "../../hooks/usePagination"
import { useState,useEffect, useCallback } from "react"
import Breadcrumbs from "../../coreComponents/breadcrumbs"
import { Button,Card, Modal, ModalHeader, ModalBody,ModalFooter } from "reactstrap"
import CommonCardHeader from "../../coreComponents/CommonCardHeader"
import RightIcon from "../svg/RightIcon"
import LeftIcon from "../svg/LeftButton"
import FilterIcon from "../svg/FilterIcon"
import { useNavigate } from "react-router-dom"
import { useAppSelector } from "../../reduxToolkit/hooks"
import ApiService from "../../services/apiService"
import { color } from "highcharts"
import Update from "../table/Update"
import routes from "../../routers/routes"
import LoadingComponent from "../lodingComponent"
import { toast } from "react-toastify"
import { Filter } from "react-feather"
const PumpingStation =() =>{

    const role = useAppSelector((state:any)=> state.role.role)
    const navigate = useNavigate();
    const [isDelteModalOpen , setIsDeleteModalOpen] = useState<boolean>(false)
    const [slectedStationId, setSelectedStationId] = useState<any>()

/* handle api fetching and pagination logic */
    const {
        data,
        pageNumber,
        setPageNumber,
        pageSize,
        totalCount,
        setRefresh,
        searchQuery,
        setSearchQuery,
        filterOn,
        setSortBy,
        loading

    } = usePagination({
         endpoint:`/pumpingstation`,
         filterOn:'Name',
         enabled:true
    })
     
    const totalPages= Math.ceil(totalCount/pageSize)

    const handleNext = useCallback(()=>{
          setPageNumber((prev) => Math.min(totalPages, prev +1))
    },[setPageNumber,totalPages])

    const handlePrev = useCallback(()=>{
         setPageNumber((prev)=> Math.max(1,prev -1 ))
    },[setPageNumber,totalPages])

/* ------------------------------------------------------------ */


 /* handle update and delete logic */

 const handlePumpingStation = (id:string) =>{
     navigate(`/pumpingstation-update/${id}`)
 }

 const handleDelete = (id:string) =>{
     setSelectedStationId(id);
     setIsDeleteModalOpen(true);
 }

 /***************************************************************** */
 const handleDeleteConfirm = async (StationId:string) =>{
      
    try{
         const response = await ApiService.axiosApi(`/pumpingstation/${StationId}`,{
            method:'DELETE'
          })

         if( response.success){
            toast.success('Pumping Station deleted successfully')
            setIsDeleteModalOpen(false)
            setRefresh(prev => !prev )
         }else{
            toast.error('Failed to delete Pumping Station')
         }
            
    }catch(error){
        console.log(error)
    }
 }

    return(
        <>
        <Breadcrumbs mainTitle="Pumping Stations" parent="Pumping Station"/>
        
             <Card>
                 <CommonCardHeader title="Pumping Station List" headClass="pb-3"/>
                 <div className='d-flex justify-content-between'>
                      <div style={{marginLeft:'10px'}} className='align-items-center flex-row d-flex'>
                          <div>
                             <input 
                               type="text"
                               className="search-input"
                               placeholder="...search"
                               value={searchQuery}
                               onChange={(e) => {
                                   setSearchQuery(e.target.value)
                                   setPageNumber(1)
                               }}
                               />
                          </div>
                           <div>
                              <button className='filter-button mx-2 p-1' style={{height:'30px'}} onClick={()=>setSortBy('ChackName')}>
                                 <Filter/>
                              </button>
                           </div>
                      </div>

                        { role === 'Administrator' && (
                            <div className='d-flex justify-content-end'>
                                 <Button onClick={()=> navigate(`/pumpingstation-add`)}color="primary" className="mb-2 mx-2">
                                     Add Pumping Station
                                 </Button>
                            </div>
                        )
                             
                        }
                 </div>
                        {loading?<LoadingComponent/>:<Table
                     data={data}
                     columns ={[
                          { header:'Name', accessor: 'name'},
                          {header:'Type', accessor:'type'},
                          {header:'Number Of Pumps', accessor:'no_Of_Pumps'},
                          {header:'Include In Dashboard', accessor:'includeInDashboard'}
                     ]}

                     buttons={[
                         {label:'Edit' , onClick:handlePumpingStation ,color:'primary', className:'me-2'},
                         {label:'Delete', onClick:handleDelete, color:'danger'}
                         
                     ]}
                   />}
                  
                    <div className=" d-flex justify-content-end align-content-center" style={{ marginRight: '10px', marginTop: '10px' }}>
                        <p style={{ marginRight: '10px', marginTop: '8px' }}>
                            Page {pageNumber} of {totalPages}
                        </p>
                        <button
                            onClick={handlePrev}
                            disabled={pageNumber === 1}
                            className={`icon-button ${pageNumber === totalPages ? `icon-button` : ''}`}
                        >
                            <LeftIcon className="icon" />
                        </button>
                        <button
                            className={`icon-button ${pageNumber === totalPages ? 'disabled' : ''}`}
                            onClick={handleNext}
                            disabled={pageNumber === totalPages}
                        >
                            <RightIcon className="icon" />
                        </button>
                    </div>
             </Card>
             <Modal isOpen={isDelteModalOpen} toggle={() => setIsDeleteModalOpen(!isDelteModalOpen)}>
                    <ModalHeader>Delete Chack</ModalHeader>
                    <ModalBody>Are you sure you want to delete this chak?</ModalBody>
                    <ModalFooter>
                        <Button color="danger" onClick={() => handleDeleteConfirm(slectedStationId)}>Delete</Button>
                        <Button color="secondary" onClick={() => setIsDeleteModalOpen(false)}>Cancel</Button>
                    </ModalFooter>
                </Modal>

         
       
          
         </>
    )
}

export default PumpingStation 
